import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { TarefasEmpresaService } from 'src/app/empresas/services/tarefas-empresa.service';
import { HomeService } from 'src/app/home/home-service/home.service';

export interface ContatoTarefa {
  id: number;
  name: string;
}

@Component({
  selector: 'app-criar-tarefa-empresa',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './criar-tarefa-empresa.component.html',
  styleUrl: './criar-tarefa-empresa.component.scss',
})
export class CriarTarefaEmpresaComponent implements OnInit {
  @Input() empresaId = 0;
  @Input() empresaNome = '';
  @Input() contatos: ContatoTarefa[] = [];

  @Output() fechar = new EventEmitter<void>();
  @Output() tarefaCriada = new EventEmitter<void>();

  responsibleID = '';
  actionID = '';
  data = '';
  hora = '';
  description = '';
  erro = false;
  carregando = false;

  responsaveis: any[] = [];
  acoes: any[] = [];

  private readonly _tarefasService = inject(TarefasEmpresaService);
  private readonly _homeService = inject(HomeService);

  ngOnInit(): void {
    this.popularResponsaveis();
    this.popularAcoes();
  }

  popularResponsaveis(): void {
    this._homeService.listResponsables().subscribe({
      next: (res: any) => {
        this.responsaveis = (res?.data ?? []).sort((a: any, b: any) => a.name.localeCompare(b.name));
      },
      error: () => {},
    });
  }

  popularAcoes(): void {
    this._tarefasService.listarAcoes().subscribe({
      next: (res: any) => {
        this.acoes = res?.data ?? [];
      },
      error: () => {},
    });
  }

  formatFollowUp(): string {
    if (!this.data || !this.hora) return '';
    const [yyyy, mm, dd] = this.data.split('-');
    const horaFormatada = this.hora.length === 5 ? `${this.hora}:00` : this.hora;
    return `${yyyy}-${mm}-${dd}T${horaFormatada}`;
  }

  criar(): void {
    this.erro = false;

    const contactIds = this.contatos.map((c) => c.id).filter((id) => !!id);

    if (
      !this.empresaId ||
      !contactIds.length ||
      !this.responsibleID ||
      !this.actionID ||
      !this.data ||
      !this.hora
    ) {
      this.erro = true;
      return;
    }

    const body = {
      targetCompanyID: this.empresaId,
      contactIds,
      responsibleID: Number(this.responsibleID),
      actionID: Number(this.actionID),
      followUp: this.formatFollowUp(),
      description: this.description,
    };

    this.carregando = true;
    this._tarefasService.criarTarefa(body).subscribe({
      next: (res: any) => {
        this.carregando = false;
        const criadas = res?.data?.created ?? contactIds.length;
        const mensagem = criadas > 1 ? `${criadas} tarefas criadas com sucesso!` : 'Tarefa criada com sucesso!';

        Swal.fire('Sucesso!', mensagem, 'success').then(() => {
          this.tarefaCriada.emit();
          this.fechar.emit();
        });
      },
      error: (err) => {
        this.carregando = false;
        Swal.fire('Erro', err?.error?.message ?? 'Não foi possível criar a tarefa.', 'error');
      },
    });
  }
}